export const routesAccount = [{
    name: 'account:settings',
    path: `/account`,
    component: () => import('@/views/Account.vue'),
    meta: {
      title: 'Account',
      description: 'Account settings for a given Identity Key'
    }
  },{
    name: 'account:restore',
    path: `/restore`,
    component: () => import('@/views/Restore.vue'),
    meta: {
      title: 'Restore Account',
      description: 'To restore a given Identity Key from seed or Private Key'
    }
  },{
    name: 'account:redeem',
    path: `/redeem`,
    component: () => import('@/views/Gateway.vue'),
    meta: {
      title: 'Redeem Invite',
      description: 'Redeem an invitation token'
    }
  },{
    name: 'account:invites',
    path: `/invites`,
    component: () => import('@/views/Invites.vue'),
    meta: {
      title: 'Invites Manager',
      description: 'Manage an invitation tokens'
    }
}]
